import React from 'react';

function ProductionSummaryCard({ title, data }) {
  return (
    <div className="card shadow rounded-4 p-3 h-100">
      <h6 className="fw-semibold mb-3">{title}</h6>
      <table className="table table-sm table-bordered mb-0">
        <thead className="table-light">
          <tr>
            <th>Label</th>
            <th>Count</th>
            <th>Total (MTS)</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(data).map(([key, val]) => (
            <tr key={key}>
              <td>{key}</td>
              <td>{val.count}</td>
              <td>{val.qty.toFixed(3)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ProductionSummaryCard;
